import {ReactElement, useState} from "react";
import {Body, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {Button} from "@zendeskgarden/react-buttons";
import {Checkbox, Field, Label} from "@zendeskgarden/react-forms";
import UserFormInput from "../../users/components/user-form/UserFormInput";
import * as formCss from "../../users/components/user-form/styles/userFormStyles.module.scss";
import {useCreatePayrollJurisdictionMutation, useUpdatePayrollJurisdictionMutation} from "../../../../__generated__/generated_types";
import {toast} from "react-toastify";

interface JurisdictionFormModalProps {
    closed: (saved: boolean) => void;
    existingJurisdiction?: {
        id: string;
        name: string;
        disabled: boolean;
    };
}

export function JurisdictionFormModal(props: JurisdictionFormModalProps): ReactElement {
    const [createJurisdiction, {loading: createLoading}] = useCreatePayrollJurisdictionMutation({});
    const [updateJurisdiction, {loading: updateLoading}] = useUpdatePayrollJurisdictionMutation({});
    const [name, setName] = useState<string>(props.existingJurisdiction?.name ?? "");
    const [nameTouched, setNameTouched] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(props.existingJurisdiction?.disabled ?? false);

    function doSave(): void {
        let promise: Promise<unknown>;
        if(props.existingJurisdiction) {
            promise = updateJurisdiction({
                variables: {
                    id: props.existingJurisdiction.id,
                    name: name,
                    disabled: disabled
                }
            });
        } else {
            promise = createJurisdiction({
                variables: {
                    name: name
                }
            });
        }

        promise.then(() => {
            toast.success("Jurisdiction Saved!");
            props.closed(true);
        }).catch(() => {/* Do Nothing */});
    }

    return <Modal>
        <Header>
            {props.existingJurisdiction ? "Edit Jurisdiction" : "Create Jurisdiction"}
        </Header>
        <Body>
            <form className={formCss.userForm}>
                <UserFormInput
                    label="Name"
                    placeholder="Jurisdiction Name"
                    required
                    value={name}
                    error={nameTouched && name === "" ? "Name cannot be empty." : undefined}
                    onChange={(evt) => {
                        setName(evt.target.value);
                        setNameTouched(true);
                    }}
                    onBlur={() => {/* Do Nothing */}}
                />

                {props.existingJurisdiction &&
                    <Field>
                        <Checkbox
                            checked={disabled}
                            onChange={(e) => setDisabled(e.target.checked)}
                        >
                            <Label>Disabled</Label>
                        </Checkbox>
                    </Field>
                }
            </form>
        </Body>
        <Footer>
            <FooterItem>
                <Button onClick={() => props.closed(false)}>Cancel</Button>
            </FooterItem>
            <FooterItem>
                <Button
                    isPrimary
                    disabled={createLoading || updateLoading || !(name && name !== "")}
                    onClick={() => doSave()}
                >Save</Button>
            </FooterItem>
        </Footer>
    </Modal>;
}
